import { CurrencyPipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BillItem } from '../../bill-splitter.models';

export interface BillPersonCard {
  id: string;
  name: string;
  total: number;
  adjustments: number;
  items: Array<{ item: BillItem; shared: boolean; total: number }>;
}

@Component({
  selector: 'app-bill-person', imports: [CurrencyPipe],
  templateUrl: './bill-person.component.html', styleUrl: './bill-person.component.scss',
})
export class BillPersonComponent {
  @Input({ required: true }) person!: BillPersonCard;
  @Input() currency = 'EUR';
  @Input() busy = false;
  @Output() renamed = new EventEmitter<string>();
  @Output() removed = new EventEmitter<void>();
  @Output() edited = new EventEmitter<BillItem>();
  @Output() shared = new EventEmitter<string>();
  @Output() itemDragged = new EventEmitter<{ event: DragEvent; itemId: string }>();
  @Output() dragFinished = new EventEmitter<void>();
}
